import videojs from 'video.js'
import 'video.js/dist/video-js.min.css'

export default () => {
  return {
    link: ($scope, $element) => {
      const video = $element[0];
      const player = videojs(video, {});
    }
  };
}
